var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3764 10.282L8.37645 10.3012M18.3668 5.282L8.36683 5.30125M18.3861 15.282L8.38608 15.3012M5.04313 10.3077C5.04401 10.7679 4.67164 11.1417 4.2114 11.1426C3.75116 11.1435 3.37735 10.7711 3.37646 10.3109C3.37558 9.85063 3.74795 9.47681 4.20819 9.47593C4.66843 9.47504 5.04224 9.84742 5.04313 10.3077ZM5.0335 5.30766C5.03439 5.7679 4.66201 6.14171 4.20177 6.1426C3.74154 6.14348 3.36772 5.77111 3.36684 5.31087C3.36595 4.85063 3.73833 4.47682 4.19857 4.47593C4.6588 4.47505 5.03262 4.84743 5.0335 5.30766ZM5.05275 15.3076C5.05364 15.7679 4.68126 16.1417 4.22103 16.1426C3.76079 16.1435 3.38698 15.7711 3.38609 15.3109C3.3852 14.8506 3.75758 14.4768 4.21782 14.4759C4.67805 14.475 5.05187 14.8474 5.05275 15.3076Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.4778f4aa545c9c299666b8b7b1b0307b.svg";
export { ForwardRef as ReactComponent };